/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_4Inputs */

const vi_irrigation_weekday_4 = /** @type {(inputs: Irrigation_Weekday_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T5`)
};

/**

* @param {Irrigation_Weekday_4Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_4 = /** @type {((inputs?: Irrigation_Weekday_4Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_4Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_4(inputs)
});